/**
 * `movements` — sorties, retours, dépôts, prêts, transports (base galerie, 4.1)
 * [palier Galerie].
 */
import { z } from 'zod';
import { centimesPositifsSchema, deviseSchema, idSchema, withAudit } from './commun.js';
export const TYPES_MOUVEMENT = [
    'sortie',
    'retour',
    'transfert',
    'depot',
    'pret',
    'transport',
];
export const typeMouvementSchema = z.enum(TYPES_MOUVEMENT);
export const ETATS_MOUVEMENT = ['prevu', 'en_cours', 'termine', 'annule'];
export const etatMouvementSchema = z.enum(ETATS_MOUVEMENT);
export const assuranceSchema = z.object({
    valeurCentimes: centimesPositifsSchema.optional(),
    devise: deviseSchema.optional(),
    police: z.string().optional(),
    assureur: z.string().optional(),
});
import { statutOeuvreSchema } from './artworks.js';
/** Aller-retour : l'œuvre revient (`…/retour`). Aller simple : elle arrive (`…/arrivee`). */
export const SENS_MOUVEMENT = {
    sortie: 'aller_retour',
    retour: 'aller_simple',
    transfert: 'aller_simple',
    depot: 'aller_retour',
    pret: 'aller_retour',
    transport: 'aller_simple',
};
/** L'événement D13 posé au DÉPART ; `null` : la localisation seule bouge. */
export const EVENEMENT_AU_DEPART = {
    sortie: null,
    retour: null,
    transfert: null,
    depot: 'depot',
    pret: 'pret',
    transport: null,
};
/** L'événement D13 posé à l'ARRIVÉE d'un aller simple. */
export const EVENEMENT_A_L_ARRIVEE = {
    sortie: null,
    retour: 'retour',
    transfert: null,
    depot: null,
    pret: null,
    transport: null,
};
/** Les types qui portent un bon numéroté. */
export const TYPES_AVEC_BON = ['depot', 'pret'];
export function typeAvecBon(type) {
    return TYPES_AVEC_BON.includes(type);
}
export const CLE_MODELE_DU_BON = {
    depot: 'bon_depot',
    pret: 'bon_pret',
};
export const SERIE_DU_BON = {
    depot: 'bons-depot',
    pret: 'bons-pret',
};
export const PREFIXE_DU_BON = {
    depot: 'BD',
    pret: 'BP',
};
export const MOMENTS_CONSTAT = ['depart', 'retour'];
export const ETATS_CONSTAT = ['bon', 'usure', 'dommage'];
/** Jours avant le retour prévu où la direction est prévenue ; `-1` : en retard. */
export const JALONS_RETOUR = [7, 1, 0];
export const JALON_RETARD = -1;
export const suiviTransportSchema = z.object({
    transporteurNom: z.string().min(1).max(200).optional(),
    numeroSuivi: z.string().min(1).max(120).optional(),
    urlSuivi: z.url({ protocol: /^https?$/ }).optional(),
});
export const ligneMouvementSchema = z.object({
    oeuvreId: idSchema,
    localisationAvantId: idSchema.nullable(),
    statutAvant: statutOeuvreSchema.nullable(),
    statutPose: statutOeuvreSchema.nullable(),
    retourneeLe: z.date().nullable(),
    ignoreeAuRetour: statutOeuvreSchema.nullable(),
});
export const movementSchema = withAudit(z.object({
    _id: idSchema,
    type: typeMouvementSchema,
    etat: etatMouvementSchema.default('prevu'),
    lignes: z.array(ligneMouvementSchema).min(1).max(100),
    deId: idSchema.nullable(),
    versId: idSchema.nullable(),
    contactId: idSchema.nullable(),
    depotRecu: z.boolean().default(false).optional(),
    transporteurId: idSchema.nullable(),
    departLe: z.date(),
    retourPrevuLe: z.date().nullable(),
    retourReelLe: z.date().nullable(),
    assurance: assuranceSchema.optional(),
    suivi: suiviTransportSchema.optional(),
    bon: z
        .object({ numero: z.string().min(1), emisLe: z.date(), documentId: idSchema.nullable() })
        .nullable(),
    note: z.string().default(''),
}));
//# sourceMappingURL=movements.js.map